@if (providerOffice) {
  <div class="provider-office">
    <app-office [office]="providerOffice.office" />
    @if (providerOffice.status) {
      <div>({{ providerOffice.status | providerOfficeFaxStatus }})</div>
    }
  </div>
}
